import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_GB from '../../locales/en-GB/en-GB.json';
import fr from '../../locales/fr/fr.json';

import { i18nSharedConfig } from './sharedConfig';

const resources = {
  fr: {
    translation: fr,
  },
  'en-GB': {
    translation: en_GB,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ...i18nSharedConfig,
    resources,
  });

export { i18n };
